
/**
 * breakpoint 가 있을때,
 */

import { COMMON } from "../..";

class BreakpointFeature {
    onChangeBreakpointCallback: any[] = [];
    prevBreakPoint: string;

    constructor(private breakpoints: string[]){
        this.prevBreakPoint = this.currentBreakPoint;

        this.setEventWindowResize();
    }

    public onChangeBreakpoint(callback: ()=>any){
        this.onChangeBreakpointCallback.push(callback);
    }

    private setEventWindowResize() {
        window.addEventListener('resize', (evt) => {
            if (this.prevBreakPoint != this.currentBreakPoint) {

                this.onChangeBreakpointCallback.map(callback=>callback());

                this.prevBreakPoint = this.currentBreakPoint;
            }
        })
    }

    public static hasBreakpoints( breakpoints: string[]){
       return  breakpoints.map(e=>Number(e)).filter(e=>!isNaN(e)).length > 0 && true || false;
    }

    public get currentBreakPoint(): Breakpoint {
        const windowWidth = window.innerWidth;
        const breakPointsNum = this.breakpoints.map(e=>Number(e));
        const candidateBreakPoints = breakPointsNum.filter(e => (e) >= windowWidth);

        if (candidateBreakPoints.length > 0) {
            return String(Math.min(...candidateBreakPoints));
        }else{
            return COMMON;
        }
    }
}

export default BreakpointFeature;
